
import { defineComponent, onBeforeMount, ref } from 'vue';
import { invokegetAllProgram, invokegetAllTaskByProgram } from '@/utils/admin/task_management_service';
// eslint-disable-next-line
import router from '@/router';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { invokegetSkillProf } from '@/utils/admin/assign_proxy_service';

export default defineComponent({
  name: 'OffcycleManagement',
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    const programDetails = ref();
    const renderReady = ref(true);
    const taskDetails = ref();
    const taskCheckOne = ref([]);
    const selectedProgram = ref(props.query.Program_id);
    const taskBtn = ref();
    const checkedTaskId = ref();
    const userRole = ref();
    const showScreen = ref(true);
    const errorMessage = ref();
    const successMessage = ref();
    const archiveBtn = ref(false);
    const unArchiveBtn = ref();
    const skills = ref();
    const proficiency = ref();
    const selectedSkill = ref(props.query.skill_id);
    console.log('selectedSkill', selectedSkill);
    const selectedProficiency = ref(props.query.proficiency_id);
    const showSkillProf = ref(false);
    const searchBtn = ref(false);
    const skillName = ref();
    const programName = ref();
    const profName = ref();
    const newTaskDetails = ref();
    const taskData = {};
    const taskcheckedOne = () => {
      taskCheckOne.value = [];
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showTaskBtn = (event: any, taskId: any, isArchive: any) => {
      const cb = event.target.checked;
      if (cb === true) {
        checkedTaskId.value = taskId;
        taskBtn.value = true;
        if (isArchive === true) {
          archiveBtn.value = false;
          unArchiveBtn.value = true;
        } else {
          archiveBtn.value = true;
          unArchiveBtn.value = false;
        }
      } else {
        taskBtn.value = false;
        archiveBtn.value = false;
        unArchiveBtn.value = false;
      }
    };
    const getTaskDetails = async () => {
      renderReady.value = false;
      Object.assign(taskData, { program_id: selectedProgram.value });
      Object.assign(taskData, { skill_id: selectedSkill.value });
      Object.assign(taskData, { proficiency_id: selectedProficiency.value });
      console.log('taskdata', taskData);
      taskDetails.value = await invokegetAllTaskByProgram('/getAllTaskByProgram', taskData);
      renderReady.value = true;
    };
    const getProgram = async () => {
      renderReady.value = false;
      programDetails.value = await invokegetAllProgram('/cache?cache=program');
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const prog = programDetails.value.find((program: any) => program.program_id === selectedProgram.value);
      programName.value = prog.program_display_name ? prog.program_display_name : prog.program_name;
      renderReady.value = true;
    };
    const getSkillandProf = async () => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const dataRes: any = await invokegetSkillProf('/getAllSkillProf?skill_type=genome');
      skills.value = dataRes.skill;
      proficiency.value = dataRes.proficiency;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      skillName.value = skills.value.find((skill: any) => skill.skill_id === selectedSkill.value).skill_alias;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      profName.value = proficiency.value.find((prof: any) => prof.prof_id === selectedProficiency.value).prof_name;
      renderReady.value = true;
    };
    const createOffCycle = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const programDetail = programDetails.value.find((program: any) => program.program_id === selectedProgram.value);
      console.log(`programDetail ${JSON.stringify(programDetail)}`);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const taskDetail = taskDetails.value.find((task: any) => task.task_id === checkedTaskId.value);
      console.log(`taskDetail ${JSON.stringify(taskDetail)}`);
      console.log('programId', selectedProgram.value);
      console.log('programName', programDetail.program_name);
      console.log('linkedTaskId', checkedTaskId.value);

      console.log('taskName', taskDetail.task_name);
      console.log('taskType', taskDetail.task_type);
      localStorage.setItem('programId', selectedProgram.value);
      localStorage.setItem('programName', programDetail.program_name);
      localStorage.setItem('linkedTaskId', checkedTaskId.value);
      if (selectedProgram.value === 'infinity') {
        localStorage.setItem('skillId', selectedSkill.value);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const skillDetail = skills.value.find((skill: any) => skill.skill_id === selectedSkill.value);
        console.log(`skillDetail ${JSON.stringify(skillDetail)}`);
        localStorage.setItem('skillName', skillDetail.skill_alias);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const profDetail = proficiency.value.find((prof: any) => prof.prof_id === selectedProficiency.value);
        console.log(`profDetail ${JSON.stringify(profDetail)}`);
        localStorage.setItem('proficiencyId', selectedProficiency.value);
        localStorage.setItem('proficiencyName', profDetail.prof_name);
        console.log('skill', selectedSkill.value);
        console.log('skill Name', skillDetail.skill_alias);
        console.log('proficiency', selectedProficiency.value);
        console.log('prof Name', profDetail.prof_name);
      }
      localStorage.setItem('taskName', taskDetail.task_name);
      localStorage.setItem('taskType', taskDetail.task_type);
      router.push({ name: 'SolidifyAdministrationCreateOffCycle' });
    };
    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');

      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        if (userRole.value.includes('System Admin') || userRole.value.includes('System Admin View Access') || userRole.value.includes('Community Manager') || userRole.value.includes('Program Admin')) {
          showScreen.value = true;
        } else {
          showScreen.value = false;
        }
      }
      await getProgram();
      await getTaskDetails();
      newTaskDetails.value = taskDetails.value.filter((task) => task.is_archive === false);
      searchBtn.value = true;
      if (selectedProgram.value === 'infinity') {
        await getSkillandProf();
        showSkillProf.value = true;
      } else {
        showSkillProf.value = false;
      }
    });
    return {
      renderReady,
      programDetails,
      taskDetails,
      newTaskDetails,
      taskCheckOne,
      taskcheckedOne,
      checkedTaskId,
      showTaskBtn,
      taskBtn,
      showScreen,
      selectedProgram,
      errorMessage,
      successMessage,
      archiveBtn,
      unArchiveBtn,
      getTaskDetails,
      skills,
      proficiency,
      showSkillProf,
      searchBtn,
      createOffCycle,
      selectedSkill,
      selectedProficiency,
      skillName,
      profName,
      programName,
    };
  },
});
